import { FC, useEffect } from 'react'
import { Layout as AntdLayout, Button, Flex } from 'antd'
import { Outlet, useLocation, Link } from 'react-router'
import { useOktaAuth } from '@okta/okta-react'
import { PageSpinner } from '@signifyd/components'
import styles from './Layout.less'

const AppLayout: FC = () => {
  const location = useLocation()
  const { oktaAuth, authState } = useOktaAuth()

  useEffect(() => {
    // Attempt sign in upon page load only on default page
    if (authState && !authState.isAuthenticated && location.pathname === '/') {
      void oktaAuth.signInWithRedirect({})
    }
  }, [authState, oktaAuth, location.pathname])

  if (!authState) {
    return <PageSpinner />
  }

  const { Header, Content, Footer } = AntdLayout

  return (
    <AntdLayout className={styles.layout}>
      <Header style={{ backgroundColor: 'black' }}>
        <Flex justify="space-between" align="center">
          <Flex className={styles.navLinks} align="center">
            <Link
              className={styles.buttonText}
              data-analytics-id="frontendHubLink"
              to="/"
            >
              Frontend Hub
            </Link>
          </Flex>

          <div>
            {!authState.isAuthenticated && (
              <Button
                type="link"
                className={styles.buttonText}
                onClick={() => oktaAuth.signInWithRedirect({})}
              >
                Log in
              </Button>
            )}

            {authState.isAuthenticated && (
              <Button
                type="link"
                className={styles.buttonText}
                onClick={() => {
                  localStorage.setItem('originalUrl', '')
                  void oktaAuth.signOut({})
                }}
              >
                Sign out
              </Button>
            )}
          </div>
        </Flex>
      </Header>
      <Content className={styles.content}>
        <Outlet />
      </Content>
      <Footer className={styles.footer}>Signifyd</Footer>
    </AntdLayout>
  )
}

export default AppLayout
